/**
 * Formats a date string to EMEA format: "09 May 2026"
 * @param dateString - Date string in ISO format (e.g., "2026-05-09" or "2026-05-09T00:00:00")
 * @returns Formatted date string in EMEA format (e.g., "09 May 2026")
 */
export const formatDateToEMEA = (dateString: string | null | undefined): string => {
  if (!dateString) {
    return '-';
  }

  try {
    const date = new Date(dateString);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return dateString; // Return original string if invalid
    }

    // Format to EMEA format: "09 Mai 2026" (French month names)
    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = [
      'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString; // Return original string on error
  }
};

/**
 * Formats a date string to short EMEA format: "09 May 2026"
 * This is an alias for formatDateToEMEA for consistency
 */
export const formatDate = formatDateToEMEA;

